<template>
  <transition name="VERTICAL" mode="out-in">
    <div v-if="isFetching || hasPauses" class="PAUSED-LEADS-LIST">
      <transition-group
          name="VERTICAL"
          tag="div"
          class="PAUSED-LEADS-LIST-CONTAINER"
      >
        <paused-leads-list-item
            v-for="(pause, index) in sortedPausesByStartDate"
            :key="index"
            :id="pause.id"
            :pause="pause"
            class="LIST-ITEM"
            @onEdit="$emit('onEdit', pause)"
            @onDelete="$emit('onDelete', pause)"
        />
        <template v-if="isFetching">
          <paused-leads-list-item-placeholder
              v-for="(placeholder, index) in 3"
              :key="`placeholder-${index}`"
              class="LIST-ITEM"
          />
        </template>
      </transition-group>
    </div>
    <paused-leads-list-placeholder v-else-if="!hasPauses" />
  </transition>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

import PausedLeadsListPlaceholder from './PausedLeadsListPlaceholder';
import PausedLeadsListItem from './PausedLeadsListItem';
import PausedLeadsListItemPlaceholder from './PausedLeadsListItemPlaceholder';

export default {
  name: 'paused-leads-list',
  components: {
    PausedLeadsListPlaceholder,
    PausedLeadsListItem,
    PausedLeadsListItemPlaceholder,
  },
  data () {
    return {
      isFetching: false,
      hasFetched: false,
    };
  },
  computed: {
    ...mapGetters('account/pro', [
      'serviceProviderCatalogOccupations',
      'unavailabilities',
      'occupationUnavailabilities',
    ]),
    sortedPausesByStartDate () {
      return this.unavailabilities.concat(this.occupationUnavailabilities)
        .sort((a, b) => {
          return new Date(a.startDate) - new Date(b.startDate);
        });
    },
    serviceProviderOccupationIds () {
      return Object.keys(this.serviceProviderCatalogOccupations);
    },
    hasPauses () {
      return this.sortedPausesByStartDate.length > 0 && this.hasFetched;
    },
  },

  mounted () {
    this.loadPauses();
  },
  methods: {
    ...mapActions('account/pro', [
      'createServiceProviderUnavailability',
      'fetchServiceProviderUnavailabilities',
      'fetchServiceProviderOccupationUnavailabilities',
      'createServiceProviderOccupationUnavailability',
    ]),
    async loadPauses () {
      this.isFetching = true;
      await Promise.all([this.fetchSelectedOccupationPauses(), this.fetchPauses()]);
      this.isFetching = false;
      this.hasFetched = true;
    },
    async fetchPauses () {
      try {
        await this.fetchServiceProviderUnavailabilities();
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
    },
    async fetchSelectedOccupationPauses () {
      try {
        const params = {
          from: 0,
          size: 100,
          service_provider_occupation_ids: this.serviceProviderOccupationIds.join(','),
        };
        await this.fetchServiceProviderOccupationUnavailabilities(params);
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .PAUSED-LEADS-LIST {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow-y: hidden;

    .VERTICAL-leave-active {
      @include absolute;
    }
  }

  .HEADING {
    @include text-large;
    @include margin(2, 4 0 2);
    font-weight: 700;

    @include tablet {
      @include h5;
    }
  }

  .PAUSED-LEADS-LIST-CONTAINER {
    @include responsive(border-left, none, 1px solid $color-gray30);
    @include responsive(border-right, none, 1px solid $color-gray30);
    position: relative;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    background-color: white;
    border-top: 1px solid $color-gray30;
    border-bottom: none;
    overflow-y: scroll;
  }

  .GROUP {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    transition: all $transition-duration;
  }

  .GROUP-HEADING {
    position: sticky;
    display: flex;
    top: 0;
    align-items: center;
    padding: $unit 2*$unit;
    font-weight: 600;
    background-color: $color-gray20;
    border-bottom: 1px solid $color-gray30;
    transition: all $transition-duration;
  }

  .LIST-ITEM {
    transition: all $transition-duration;
  }
</style>
